import { lazy, Suspense } from "react";
import { Link, Route, Switch } from "wouter";
import Landing from "./pages/Landing";
import { Page } from "./ui/Layout";

// Everything except the landing page is a separate chunk to keep first load small.
const Pricing = lazy(() => import("./pages/Pricing"));
const Advertise = lazy(() => import("./pages/Advertise"));
const CallRoute = lazy(() => import("./call/CallRoute"));
const Workspace = lazy(() => import("./pages/Workspace"));

function NotFound() {
  return (
    <Page>
      <div className="mx-auto max-w-xl px-4 py-24 text-center">
        <h1 className="text-3xl font-bold">We can't find that page</h1>
        <Link href="/" className="mt-6 inline-block rounded-full bg-accent px-6 py-3 font-semibold text-white">
          Go home
        </Link>
      </div>
    </Page>
  );
}

function Loading() {
  return <div className="flex min-h-dvh items-center justify-center text-muted">Loading…</div>;
}

export default function App() {
  return (
    <Suspense fallback={<Loading />}>
      <Switch>
        <Route path="/" component={Landing} />
        <Route path="/pricing" component={Pricing} />
        <Route path="/advertise" component={Advertise} />
        <Route path="/workspace" component={Workspace} />
        <Route path="/r/:code">{(p) => <CallRoute code={p.code} />}</Route>
        <Route component={NotFound} />
      </Switch>
    </Suspense>
  );
}
